import { render, staticRenderFns } from "./LecturesList.vue?vue&type=template&id=6446981e&scoped=true&"
import script from "./LecturesList.vue?vue&type=script&lang=js&"
export * from "./LecturesList.vue?vue&type=script&lang=js&"
import style0 from "./LecturesList.vue?vue&type=style&index=0&id=6446981e&lang=scss&scoped=true&"
import style1 from "./LecturesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6446981e",
  null
  
)

export default component.exports